import React from "react";
import "./Footer.css";
import { Link } from "react-router-dom";
import VerticalAlignTopIcon from "@material-ui/icons/VerticalAlignTop";

function Footer() {
  const backToTopClick = () => {
    window["scrollTo"]({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="footerarea">
      <div className="footerarea__links">
        <div className="shopTitle">
          Site maintained by
          <br />
          Parana Eshop Services
        </div>
        <div className="backToTop__span">
          <Link className="backtotop_link">
            <div className="backToTop" onClick={backToTopClick}>
              <span className="icon_details">Back To Top</span>
              <VerticalAlignTopIcon />
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
}
export default Footer;
